// COMPARTILHAR A TEMPORADA: transformar o que aconteceu num link.
//
// ============================================================================
// POR QUE ISTO EXISTE
//
// O 82-0, o concorrente que cresceu, vive de "crie um link e desafie um
// amigo". O 82 Basquete nao tinha NADA de compartilhar -- o unico uso de
// clipboard no projeto inteiro era o copia-e-cola do Pix.
//
// Mas o 82 tem uma coisa que um jogo de draft rapido nao tem: historia. Dez
// temporadas, titulos, demissoes, um cestinha com nome. Isso ja esta tudo
// gravado no save (`history`, `trophies`, `leader`) desde que a temporada
// fecha -- nada aqui recalcula nada, so empacota.
//
// ⚠️ O LINK E PUBLICO E FICA PUBLICO. So vai para o servidor o que a pessoa
// veria numa sumula: clube, campanha, trofeus, cestinha e o nome de tecnico
// que ela mesma digitou. Nada de e-mail, e nada que ligue o cartao a conta.
// ============================================================================

import React, { useState } from 'react';
import { apiUrl } from './api.js';
import { marcar } from './analytics.js';

/** Monta o corpo do cartao a partir de uma linha do historico. */
export function cartaoDaTemporada(state, registro) {
  return {
    clube: registro.userTeamName,
    liga: registro.leagueId,
    temporada: registro.season,
    vitorias: registro.userRecord?.wins ?? 0,
    derrotas: registro.userRecord?.losses ?? 0,
    posicao: registro.posicao ?? null,
    trofeus: registro.trophies || (registro.trophy ? [registro.trophy] : []),
    cestinha: registro.leader?.name || null,
    pontos: registro.leader?.ppg ?? null,
    tecnico: state.coachName || null,
  };
}

/**
 * O botao.
 *
 * ⚠️ `navigator.share` PRIMEIRO, area de transferencia depois. No celular --
 * que e onde 70% joga (ver PLANO.md) -- o share nativo abre WhatsApp e
 * Instagram direto, e e ali que o link circula. No computador ele nao existe,
 * e copiar e o certo. Tentar so copiar em tudo desperdicaria o caminho bom.
 */
export function CompartilharTemporada({ state, registro, className = '' }) {
  const [estado, setEstado] = useState('parado');   // parado | criando | pronto | erro
  const [erro, setErro] = useState(null);

  const compartilhar = async () => {
    setEstado('criando');
    setErro(null);
    try {
      const r = await fetch(apiUrl('/api/cartao'), {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(cartaoDaTemporada(state, registro)),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || !j.id) throw new Error(j.error || 'Nao consegui criar o cartao.');

      /* ⚠️ `new URL(..., location.href)` e NAO `location.origin + apiUrl(...)`.
         O build usa base relativa (`base: './'` no vite.config), entao
         `apiUrl` devolve `./cartao/xyz`. Concatenar isso com a origem produzia
         `http://82basquete.com.br./cartao/xyz` -- com um ponto perdido no meio,
         um link que o botao anunciava como pronto e que nao abria em lugar
         nenhum. `new URL` resolve o relativo do jeito certo, e continua certo
         quando o jogo mora em /82basquete/. */
      const link = new URL(apiUrl(`/cartao/${j.id}`), location.href).href;
      marcar('cartao_criado', { liga: registro.leagueId, temporada: registro.season });

      const texto = `${registro.userTeamName} · temporada ${registro.season} no 82 Basquete`;
      if (navigator.share) {
        try {
          await navigator.share({ title: texto, text: texto, url: link });
          setEstado('pronto');
          return;
        } catch (e) {
          /* Cancelar o menu de compartilhar tambem cai aqui, e cancelar nao e
             erro: cair para a copia deixa o link na mao de quem desistiu do
             menu mas ainda quer mandar. */
        }
      }
      await navigator.clipboard.writeText(link);
      setEstado('pronto');
    } catch (e) {
      setErro(String(e?.message || e));
      setEstado('erro');
    }
  };

  return (
    <div className={className}>
      <button
        className="ghost sm"
        style={{ width: '100%' }}
        disabled={estado === 'criando'}
        onClick={compartilhar}
      >
        {estado === 'criando' && 'Criando o link...'}
        {estado === 'pronto' && '✓ Link pronto — cole onde quiser'}
        {(estado === 'parado' || estado === 'erro') && 'Compartilhar esta temporada'}
      </button>
      {erro && <div className="small neg" style={{ marginTop: 6 }}>{erro}</div>}
    </div>
  );
}
